module.exports = __webpack_public_path__ + "media/fyt_m8.f218aa84.mp4";